export default __webpack_public_path__ + "static/media/slide_06.3464740e.png";